import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "./NavbarStyle.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import logo from "../../assets/images/favicon.png";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [slide, setSlide] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = () => {
    setNav(!nav);
    setSlide(!slide);
  };

  const handleClose = () => {
    setNav(false);
    setSlide(false);
  };

  const handleDownload = (event) => {
    event.preventDefault();
    handleClose();

    const scrollToDownload = () => {
      document.getElementById("download")?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    };

    if (location.pathname !== "/") {
      navigate("/#download");
      window.setTimeout(scrollToDownload, 100);
      return;
    }

    scrollToDownload();
  };
  // --------------------------------------------------------------------------------

  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlNavbar = () => {
      // Current scroll position
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 20) {
        // If scrolling down and past the header area, hide it
        setIsVisible(false);
      } else {
        // If scrolling up, show it
        setIsVisible(true);
      }

      // Update last scroll position
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", controlNavbar);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);

  return (
    <div className={`navbar ${isVisible ? "nav-show" : "nav-hide"}`}>
      <div className="container">
        <div className={slide ? "logo slide-right" : "logo"}>
          <img
            src={logo}
            alt="Logo"
            style={{
              height: 48,
              width: 48,
              background: "#fff",
              borderRadius: "12px",
              border: "2px solid #ecb003",
              padding: "4px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              objectFit: "contain"
            }}
          />
        </div>

        <ul className={nav ? "nav-menu active" : "nav-menu"}>
          <li>
            <Link to="/" onClick={handleClose}>Home</Link>
          </li>
          <li>
            <Link to="/features" onClick={handleClose}>Features</Link>
          </li>
          <li>
            <Link to="/network" onClick={handleClose}>Network</Link>
          </li>
          <li>
            <Link to="/coordination" onClick={handleClose}>Rescue Coordination</Link>
          </li>
          <li>
            <Link to="/safety" onClick={handleClose}>Safety</Link>
          </li>
          <li>
            <Link to="/#download" onClick={handleDownload}>Download</Link>
          </li>
        </ul>

        {/* <ul className="nav-menu hide">
          <li>
            <a href="/">Shop</a>
          </li>
          <li>
            <a href="/">Account</a>
          </li>
        </ul> */}

        <div className="hamburger" onClick={handleNav}>
          {nav ? (
            <FaTimes size={20} style={{ color: "#bda0a0" }} />
          ) : (
            <FaBars style={{ color: "#bda0a0" }} size={20} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
